// Re-export from langPaths.ts for backward compatibility
// TODO: Update imports to use ~/utils/langPaths directly
export type { ValidLocale } from '~/utils/langPaths'
export { supportedLanguages } from '~/utils/langPaths'
